"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function kebabRules(rulePairs, index) {
    rulePairs[index] = rulePairs[index].replace(/([A-Z])/g, '-$1').toLowerCase();
}
exports.kebabRules = kebabRules;
//# sourceMappingURL=kebabRules.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/merge-styles/lib/transforms/kebabRules.js
// module id = 975
// module chunks = 0